import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import axios from 'axios';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';
import { formatApiError } from '../../utils/errors';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

export default function CandidateForgotPassword() {
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, formState: { errors } } = useForm();

  const onSubmit = async ({ email }) => {
    setLoading(true);
    try {
      await axios.post(`${API_BASE}/auth/candidate-forgot-password`, { email }, { timeout: 20000 });
      toast.success('Check your email for reset instructions.');
    } catch (err) {
      toast.error(formatApiError(err, 'Could not send a reset link. Please try again.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4 py-8">
      <div className="w-full max-w-md">
        <div className="surface-elevated p-8">
          <h2 className="text-xl font-semibold text-slate-900 mb-2">Forgot password</h2>
          <p className="text-sm text-slate-500 mb-6">Enter the email you use for the candidate portal.</p>
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
            <Input
              label="Email"
              type="email"
              autoComplete="email"
              error={errors.email?.message}
              {...register('email', { required: 'Email is required' })}
            />
            <Button type="submit" className="w-full" loading={loading}>Send reset link</Button>
          </form>
        </div>
        <p className="text-center text-slate-500 text-sm mt-6">
          <Link to="/candidate/login" className="text-brand-600 hover:underline">Back to candidate sign in</Link>
        </p>
      </div>
    </div>
  );
}
